export const PARAMS_SEARCH_KEY = 'search';
export const PARAMS_ASIAN_SEARCH_KEY = 'asian_search';
